import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../../osm-services/category.service';

interface CategoryWithApps {
  categoryId: string;
  name: string;
  icon: string;
  iconPath: string;
  active: boolean;
  order: number;
  apps: AppInCategory[];
}

interface AppInCategory {
  appliId: string;
  name: string;
  icon: string;
  androidImageUrl: string;
  active: boolean;
  order: number;
  category: string;
  subCategory: string;
  link: string;
  fallbackUrl: string;
  fallbackUrl2: string;
  packageName: string;
  openByPackageName: boolean;
  default: boolean;
}

@Component({
  selector: 'ozm-category-browser',
  templateUrl: './category-browser.component.html',
  styleUrls: ['./category-browser.component.scss']
})
export class CategoryBrowserComponent implements OnInit {
  categories: CategoryWithApps[] = [];
  selectedCategory: CategoryWithApps | null = null;
  loading = false;
  error: string | null = null;

  constructor(private categoryService: CategoryService) { }

  ngOnInit(): void {
    this.loadCategories();
  }

  loadCategories(): void {
    this.loading = true;
    this.error = null;
    
    this.categoryService.getCategoriesWithApps().subscribe({
      next: (response) => {
        if (response && response.Items) {
          this.categories = response.Items.sort((a, b) => a.order - b.order);
          console.log('Categories loaded:', this.categories);
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading categories:', error);
        this.error = 'Failed to load categories';
        this.loading = false;
      }
    });
  }

  selectCategory(category: CategoryWithApps): void {
    this.selectedCategory = category;
    console.log('Selected category:', category);
  }

  openApp(app: AppInCategory): void {
    // Determine which URL to use
    let targetUrl = app.link;
    
    if (!targetUrl && app.fallbackUrl) {
      targetUrl = app.fallbackUrl;
    }
    
    if (!targetUrl && app.fallbackUrl2) {
      targetUrl = app.fallbackUrl2;
    }
    
    if (targetUrl) {
      if (app.openByPackageName && app.packageName) {
        // Try to open app by package name first (mobile app)
        // This would typically be handled by a mobile app framework
        console.log('Attempting to open app:', app.packageName);
      }
      
      // Open URL in new tab
      window.open(targetUrl, '_blank');
    } else {
      console.warn('No valid URL found for app:', app.name);
    }
  }

  closeSidebar(): void {
    this.selectedCategory = null;
  }

  onImageError(event: any): void {
    event.target.src = '/assets/images/default.png';
  }
}
